import React, { useEffect, useState } from "react";
import "./CountdownCircle.css";

export default function CountdownCircle({ totalTime = 60, size = 60, color = "#6f5fff" }) {
  const [timeLeft, setTimeLeft] = useState(totalTime);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  // circle calculation
  const radius = (size - 8) / 2; // adjust for stroke width
  const circumference = 2 * Math.PI * radius;
  const progress = (timeLeft / totalTime) * circumference;

  return (
    <div className="compo-countdown-wrapper" style={{ width: size, height: size }}>
      <svg className="compo-progress-ring" width={size} height={size}>
        <circle
          className="compo-progress-ring__background"
          stroke="#eee"
          strokeWidth="7"
          fill="#6f5fff"
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          className="compo-progress-ring__circle"
          stroke={color}
          strokeWidth="7"
          fill="transparent"
          r={radius}
          cx={size / 2}
          cy={size / 2}
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
        />
      </svg>
      <span className="compo-progress-text">{timeLeft}</span>
    </div>
  );
}
